import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0B132B] text-white grid place-items-center px-5 relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="relative w-full max-w-md rounded-3xl glass-dark p-8 text-center shadow-high">
        <XCircle size={56} className="mx-auto text-amber-400" />
        <div className="mt-4 font-display text-2xl">Checkout cancelled</div>
        <p className="mt-2 text-sm text-slate-400">No worries — nothing was charged. You can pick up where you left off any time.</p>
        <div className="mt-6 flex flex-col gap-3">
          <Link to="/#programs" className="inline-flex justify-center h-11 rounded-full bg-white text-[#0B132B] text-sm font-medium">Back to Programs</Link>
          <a href="https://wa.me/918824207033" target="_blank" rel="noreferrer"
             className="inline-flex justify-center h-11 rounded-full ring-1 ring-white/10 text-sm">Talk to Us on WhatsApp</a>
        </div>
      </div>
    </div>
  );
}
